<template>
  <div
    :class="[
      'cabecalho-container',
      { 'padding-bottom': paddingBottom },
      { 'padding-alerta': paddingAlerta }
    ]"
    v-if="titulo"
  >
    <div
      class="cabecalho-content"
      :class="[
        { beneficio: beneficio },
        { protocolo: protocolo },
        { guia: guia },
        { nowrap: nowrap }
      ]"
    >
      <label class="html" v-if="tipo == 'html'" v-html="titulo"></label>
      <label
        :class="['alerta', { municipios: municipios }]"
        v-else-if="tipo == 'alerta'"
        v-html="titulo"
      ></label>
      <label v-else>{{ titulo }}</label>
      <span v-if="aliquota && !tipo" v-html="formatPercent(aliquota)"></span>
      <span v-if="tipo && tipo.includes('porcentagem')">{{
        formatPercentFixed(aliquota, Number(tipo.replace("porcentagem", "")))
      }}</span>
      <span v-if="tipo == 'data'">{{ formatDate(aliquota) }}</span>
      <span v-if="tipo == 'link'" v-html="aliquotaReplace"></span>
      <span v-if="tipo == 'ncm'">{{ aliquota }}</span>
      <span v-if="tipo == 'alerta'" class="alerta">{{ aliquota }}</span>
      <span v-if="tipo == 'icone'" class="icone">
        <p>{{ aliquota }}</p>
        <AjudaIcon class="ajuda-icon" :option="aliquota" :classe="classe" />
      </span>
      <span v-if="tipo == 'guia'">
        <span>{{ aliquota }}</span>
        <a
          v-if="linkGnre"
          target="_blank"
          referrerpolicy="origin"
          :href="`http://gnre.econeteditora.com.br/validar-login/${usuarioId}`"
        >
          <img class="img-gnre" src="../../assets/images/gnre.png" />
        </a>
      </span>
      <div class="gnre" v-if="tipo == 'gnre'">
        <span>{{ aliquota }}</span>
        <a
          v-if="linkGnre"
          class="link-gnre"
          target="_blank"
          referrerpolicy="origin"
          :href="`http://gnre.econeteditora.com.br/validar-login/${usuarioId}`"
        >
          <img class="img-gnre" src="../../assets/images/gnre.png" />
        </a>
      </div>
    </div>
    <AjudaIcon
      v-if="tipo == 'icone'"
      class="ajuda-icon-impressao"
      :option="aliquota"
      :classe="classe"
    />
  </div>
</template>

<script>
import AjudaIcon from "@/components/Fields/AjudaIcon.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import dateFormatMixin from "@/mixins/dateFormatMixin";
export default {
  mixins: [stringFormatMixin, dateFormatMixin],
  name: "Cabecalho",

  props: {
    tipo: String,
    titulo: String,
    aliquota: String | Number,
    beneficio: Boolean,
    protocolo: Boolean,
    guia: Boolean,
    nowrap: Boolean,
    linkGnre: String,
    classe: String,
    paddingBottom: Boolean,
    paddingAlerta: Boolean,
    municipios: Boolean
  },

  components: {
    AjudaIcon
  },

  data() {
    return {
      usuarioId: 0
    };
  },
  created() {
    this.usuarioId = window.localStorage.getItem("id_original");
    // caso queira alterar o reffer
    // Object.defineProperty(document, "referrer", {get : function(){ return "https://rte-homol.econeteditora.com.br/cenario"; }});
  },

  computed: {
    aliquotaReplace() {
      let blank = this.strReplace(this.aliquota, "<a", "&nbsp<a target='_blank'");
      let cc = this.strReplace(blank, "</a", "&nbsp</a");
      return cc;
    }
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.cabecalho-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  label {
    font-size: 1rem;
    margin-bottom: 0;
    font-weight: 600;
  }

  span {
    // font-weight: 600;
    display: flex;
    align-items: flex-end;
    min-height: 21px;
    text-align: right;
  }
  .html {
    font-weight: normal;
  }
}

.beneficio {
  align-items: center;
  padding: 0.35rem 9px;

  label {
    margin-bottom: 0;
    font-size: 0.92rem;
  }

  span {
    font-weight: normal;
    display: flex;
    align-items: center;
  }
}

.protocolo {
  display: flex;
  align-content: flex-end;
  flex-direction: column;
}

.guia {
  align-items: flex-start;
  padding: 0.5rem 1rem;

  label {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    font-size: 0.92rem;
  }

  span {
    font-weight: normal;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
.padding-bottom {
  margin-bottom: 7px;
}

.icone {
  display: flex;
  align-items: center;
  margin: 0;
  p {
    margin: 0 5px 0 0;
  }
}

.padding-alerta {
  padding-top: 10px;
}

.alerta {
  font-size: 0.92rem !important;
  font-weight: 600;
}

.ajuda-icon-impressao {
  display: none;
}

.municipios {
  color: #207a23;
}
.nowrap {
  flex-wrap: nowrap;
  span {
    margin-left: 10px;
  }
}
.link-gnre {
  margin-left: 10px;
}
.gnre {
  display: flex;
  height: 21px;
  align-items: center;
}

@media only print {
  .ajuda-icon {
    display: none;
  }

  .ajuda-icon-impressao {
    display: flex;
    align-items: flex-start;
    border: 1px solid var(--print-borda);
    padding: 5px;
    margin: 10px 0;
  }
  .municipios {
    color: var(--preto);
  }
  .link-gnre {
    display: none;
  }
}
</style>
